module.exports = __webpack_public_path__ + "img/689-e3c4d7.png";